export default __webpack_public_path__ + "static/media/player-lauren-colour-desk@2x.7745ba7e.png";